module.exports = __webpack_public_path__ + "static/media/amusement(25).934db4a9.PNG";